<mat-card class="edit">
  <form [formGroup]="commentFormGroup">
    <mat-card-content>
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style" formControlName="type">
        <mat-button-toggle [value]="commentTypeEnum.public">Public</mat-button-toggle>
        <mat-button-toggle *ngIf="isGestionnaire" [value]="commentTypeEnum.private">Privés</mat-button-toggle>
      </mat-button-toggle-group>
      <mat-form-field appearance="outline" [ngStyle]="{'width':'100%'}">
        <mat-label>Commentaire</mat-label>
        <textarea formControlName="content" matInput [ngStyle]="{'min-height':'150px'}">{{commentFormGroup?.controls['content'].value}}</textarea>
      </mat-form-field>
    </mat-card-content>
    <mat-card-footer>
      <button class="reset" mat-raised-button color="primary" (click)="clearComment()">Annuler</button>
      <button mat-raised-button color="primary"
              [disabled]="commentSent || commentFormGroup?.controls['content'].value === ''"
              (click)="sendComment()">Envoyer</button>
    </mat-card-footer>
  </form>
</mat-card>
